<template>
  <div id="menu" class="category-list">
    <w-menu-list>
      <w-category-item
        v-for="(item, index) in categoryListComp"
        :key="`${index}__${item.code}`"
        :selected="selectedItemComp?.code === item.code"
        @click="onClickCategory(item)"
      >
        {{ item.text }}
      </w-category-item>
    </w-menu-list>
  </div>
</template>

<script>
  import WMenuList from '@/components/menu/WMenuList'
  import WCategoryItem from '@/components/header/category/WCategoryItem'
  import fp from 'lodash/fp'
  import { getCellEventObject } from '@/common/utils/gnb.fp'
  import {
    MENU,
    ON_CLICK_CELL,
    SET_CURRENT_MENU,
    TOAST_TEXT,
    UPDATE_MAIN_LAYOUT_CONTENT,
  } from '@/common/resources/const'
  import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'
  import { sendEventLogExitToGnb } from '@/common/utils/log.v2.send'
  import { parseUrl, stringify } from 'query-string'
  import _ from 'lodash'
  import { mapMutations } from 'vuex'
  import { useCategory } from '@/components/header/use/useCategory'
  import { computed } from 'vue'
  import { useRoute } from 'vue-router/composables'

  export default {
    name: 'WCategoryList',
    components: {
      WMenuList,
      WCategoryItem,
    },
    setup(props) {
      const route = useRoute()

      const { categoryListComp = [], init } = useCategory()

      const selectedItemComp = computed(() => {
        const currentCategoryCode = route.query?.mainCode
        if (!currentCategoryCode) return route.name
        return categoryListComp.value?.find(
          ({ code }) => code === currentCategoryCode,
        )
      })

      return {
        categoryListComp,
        selectedItemComp,
        init,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU]),
      updateCurrentPage() {
        this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
      },
      onClickCategory(item) {
        const { onNavigation } = fp.flow(
          fp.get('eventList'),
          getCellEventObject,
        )(item)
        const toastText = _.get(onNavigation, TOAST_TEXT, '')
        if (toastText) {
          this.$events.$emit('OPEN_PPV_TOAST', () => {}, toastText)
          this.changeCategory(item)
        } else {
          this.changeCategory(item)
        }
      },
      removeProtocolAndWavveDomain(url) {
        const [path, query] = url.split('?')
        const domain = 'www.wavve.com'
        const result = path
          .replace(/^(https?:)?\/\/[^/]+/, '')
          .replace(domain, '')
        if (query) {
          return `${result}?${query}`
        }
        return result
      },
      changeUrl(gnbInfo) {
        const { path, name } = gnbInfo
        if (this.$route.name === name) {
          this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
        } else {
          if (LOG_SEND_LIST.includes(this.$route.name))
            sendEventLogExitToGnb({
              name: name,
              route: this.$route,
              landingUrl: path,
            })
          this.$router.push(path)
        }
      },
      changeCategory(item) {
        const { onClick, onNavigation } = fp.flow(
          fp.get('eventList'),
          getCellEventObject,
        )(item)
        this.$events.$emit(ON_CLICK_CELL, onClick)
        const navigationUrl = parseUrl(_.get(onNavigation, 'url', ''))

        const isAdultOnly =
          _.get(onNavigation, 'adult', 'n').toUpperCase() === 'Y'
        if (isAdultOnly) {
          _.set(navigationUrl.query, 'adult', 'y')
        }
        const hasQuery = Object.keys(navigationUrl.query).length > 0
        if (hasQuery && _.get(navigationUrl.query, 'api', '') !== '') {
          navigationUrl.query.api = encodeURIComponent(
            _.get(navigationUrl.query, 'api', ''),
          )
        }
        const path = this.removeProtocolAndWavveDomain(
          hasQuery
            ? `${navigationUrl.url}?${stringify(navigationUrl.query)}`
            : navigationUrl.url,
        )
        if (LOG_SEND_LIST.includes(this.$route.name)) {
          sendEventLogExitToGnb({
            name: MENU.CATEGORY,
            route: this.$route,
            landingUrl: path,
          })
        }
        this[SET_CURRENT_MENU](MENU.CATEGORY)
        if (
          this.removeProtocolAndWavveDomain(this.$route.fullPath) ===
          this.removeProtocolAndWavveDomain(path)
        ) {
          this.updateCurrentPage()
        } else {
          this.$router.push(path).catch(() => {})
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .category-list {
    flex: 1;
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
